import WarrantyExtensionPanel from "./warrantyExtensionPanel.container";

export default WarrantyExtensionPanel;
